import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { Proof } from '@feature/proof';
import { generateProofApi, generateProofOptions } from '@feature/proof/proofGenerator';
import { Id } from '@feature/utils';

const translationProofApi = generateProofApi('/proof-file/translation');
const { getProofsOptions, getProofsByOwnerOptions, createOrUpdateProofOptions, deleteProofOptions } =
  generateProofOptions('translation', translationProofApi);

export function getTranslationProofsByOwnerOptions(translationId: Id, userId: Id): UseSuspenseQueryOptions<Proof[]> {
  return getProofsByOwnerOptions(translationId, userId);
}

export function getTranslationProofsOptions(translationId: Id): UseSuspenseQueryOptions<Proof[]> {
  return getProofsOptions(translationId);
}

export function useUploadOrUpdateTranslationProof(translationId: Id) {
  const queryClient = useQueryClient();
  return useMutation(createOrUpdateProofOptions(translationId, queryClient));
}

export function useDeleteTranslationProof(translationId: Id) {
  const queryClient = useQueryClient();
  return useMutation(deleteProofOptions(translationId, queryClient));
}
